/* import __COLOCATED_TEMPLATE__ from './conversation-relationship-attribute-empty-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();